import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledChildContainer = styled.div`
  width: fit-content;
  height: fit-content;
`;
export const WrappedComponent = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(StyledChildContainer, {
    ...props,
    ref: ref
  });
});
WrappedComponent.displayName = 'ToolTipWrapper';